module.exports = __webpack_public_path__ + "img/_2.7c94e164.png";